<template>
  <div class="memberCenter_wrap EnterpriseInform">
    <div class="nav_pos mb_nav_pos">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>招标/比选管理</el-breadcrumb-item>
        <el-breadcrumb-item>上传澄清回执</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrap">
      <div class="change_inform">
        <div class="title">项目信息</div>
        <el-form :inline="true" :model="PurchaseScheme" class="form_table">
          <el-form-item label="采购编号">{{ PurchaseScheme.SchemeCode }}</el-form-item>
          <el-form-item label="项目名称">{{ PurchaseScheme.ProjectName }}</el-form-item>
          <el-form-item label="投标确认截止时间（原）">{{ PurchaseScheme.TenderConfirmDate1 }}</el-form-item>
          <el-form-item label="投标确认截止时间（调整）">{{ PurchaseScheme.TenderConfirmDate2 }}</el-form-item>
          <el-form-item label="投标截止时间（原）">{{ PurchaseScheme.BiddingDeadline1 }}</el-form-item>
          <el-form-item label="投标截止时间（调整）">{{ PurchaseScheme.BiddingDeadline2 }}</el-form-item>
          <el-form-item label="开标时间">{{ PurchaseScheme.BidOpeningDate1 }}</el-form-item>
          <el-form-item label="开标时间（调整）">{{ PurchaseScheme.BidOpeningDate2 }}</el-form-item>
          <el-form-item label="审核不通过原因" v-if="PurchaseScheme.AuditRemark != ''" class="all_line">{{ PurchaseScheme.AuditRemark }}</el-form-item>
        </el-form>
      </div>
      <div class="change_inform">
        <div class="title">澄清修改文件</div>
        <el-table class="table_wrap1" :data="ClarifyFileList" style="width: 98%; margin: 0 auto" border>
          <el-table-column prop="Index" width="400px" align="center" label="序号"></el-table-column>
          <el-table-column prop="FileName" align="center" label="附件">
            <template slot-scope="scope">
              <el-link class="link" @click="fnDownLoad(scope.row.FileId)" type="text" :underline="false">{{ scope.row.FileName }}</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="change_inform">
        <div class="title">回执上传</div>
        <el-form :model="FileUpload" :rules="rules" class="form_table">
          <el-form-item prop="FileList" label="回执">
            <el-upload
              action="/Purchase/UploadClarifyFile"
              :auto-upload="true"
              :limit="1"
              accept=".pdf"
              :data="FileUpload"
              :before-upload="beforeUpload"
              :on-exceed="handleExceed"
              :file-list="FileUpload.FileList"
              :on-preview="handleDownLoad"
              :http-request="uploadSectionFile"
              :before-remove="beforeRemove"
              :on-remove="handleRemove"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>
          </el-form-item>

          <div class="btn_wrap2">
            <el-button class="btn2" @click="fnDownLoad2(TemplateFileId, '澄清回执模板')">下载模板</el-button>
          </div>
        </el-form>
      </div>
      <div class="btn_wrap">
        <span class="btn" @click.stop="CancelEvents">取消</span>
        <span class="btn" @click.stop="AcceptEvents">上传回执</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rules: {
        FileList: [{ required: true, message: '请填写联系人', trigger: 'change' }]
      },
      fileId: '',
      fileName: '',
      FileUpload: {},
      PurchaseScheme: {},
      activeName: 'first',
      qualificationList: [],
      enclosureList: [],
      type: '',
      FileList: [],
      ClarifyFileList: [],
      TemplateFileId: '',
      TemplateFileName: ''
    }
  },
  mounted() {
    this.fnInit()
  },
  methods: {
    beforeUpload(file) {
      if (file.type != 'application/pdf') {
        this.$message.warning('只能上传PDF文件!')
        return false
      } else {
        return true
      }
    },
    beforeRemove(file) {
      let isDelete = true
      if (file && file.status === 'success') {
        isDelete = this.$confirm(`确定删除 ${file.name}？`)
      }
      return isDelete
    },
    handleRemove(file) {
      if (file && file.status === 'success') {
        this.FileList = this.FileList.filter(function (item) {
          return item.id != file.id
        })
      }
    },
    uploadSectionFile(params) {
      //上传选中的文件
      const file = params.file
      var data = new window.FormData()
      data.append('file', file)
      data.append('loginToken', window.localStorage.getItem('loginToken'))
      this.uploadFileRequest('Purchase/UploadFile', data).then((res) => {
        if (res.data.errcode == 0) {
          this.FileUpload.FileList = res.data.FileList
        }
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning('只能选择1个文件!')
    },
    CancelEvents() {
      //取消，关闭页面
      window.close()
    },
    AcceptEvents() {
      //上传回执
      if (this.FileUpload.FileList == undefined || this.FileUpload.FileList == null) {
        this.$message.error('请上传澄清回执文件')
        return
      }
      let config = {
        params: {
          clarifyId: this.$route.query.id,
          fileId: this.FileUpload.FileList[0].fileId
        }
      }
      this.getRequest('/Purchase/ConfirmClarify', config)
        .then((res) => {
          var data = res.data
          if (res.data.errcode == 0) {
            this.$message.success('成功上传回执文件!')
            localStorage.setItem('ClarifyList', Math.random()) //刷新父页面
            window.close()
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleDownLoad() {
      //上传下载（下载操作）
      this.fnDownLoad(this.FileUpload.FileList[0].fileId)
    },
    fnDownLoad2(fileId, fileName) {
      //下载澄清修改文件
      let token = window.localStorage.getItem('loginToken')
      var url = 'Purchase/DownloadFile?FileId=' + fileId + '&token=' + token + '&FileName=' + fileName

      this.downloadfile(this.baseURL + url)
    },
    fnDownLoad(fileId) {
      //下载澄清修改文件
      let token = window.localStorage.getItem('loginToken')
      var url = 'Purchase/DownloadFile?FileId=' + fileId + '&token=' + token

      this.downloadfile(this.baseURL + url)
    },
    fnInit() {
      let config = {
        params: {
          clarifyId: this.$route.query.id
        }
      }
      this.getRequest('/Purchase/GetClarifyDetail', config)
        .then((res) => {
          var data = res.data
          if (res.data.errcode == 0) {
            this.ClarifyFileList = res.data.ClarifyFileList
            this.PurchaseScheme = res.data.PurchaseScheme
            this.TemplateFileId = res.data.TemplateFileId
            this.TemplateFileName = res.data.TemplateFileName
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    }
  }
}
</script>
<style lang="scss" scoped>
.mb_nav_pos {
  padding: 5px 0 0;
}
.change_inform {
  padding-top: 15px;
  .title {
    height: 34px !important;
    line-height: 40px !important;
    border-bottom: 1px solid #95c7f0 !important;
    margin-bottom: 13px;
    // padding-top: 15px !important;
  }
  ::v-deep .el-table--border::after,
  .el-table--group::after,
  .el-table::before {
    background-color: #95c7f0;
  }
  ::v-deep .table_wrap1 {
    table {
      margin: 0;
      td,
      tr,
      th {
        border-color: #95c7f0;
      }
      th {
        border-top: 1px solid #95c7f0;
        border-right: 1px solid #95c7f0;
        border-color: #95c7f0;
        background-color: #d8eafa;
        &:first-child {
          border-left: 1px solid #95c7f0;
        }
      }
      td {
        border-bottom: none;
        &:first-child {
          border-left: 1px solid #95c7f0;
        }
      }
    }
    .el-table__body-wrapper {
      border-bottom: 1px solid #95c7f0;
    }
  }
}
.btn_wrap {
  width: 360px;
  height: 40px;
  text-align: center;
  padding: 10px;
  margin: auto;
  // text-align: center;
  // margin: auto;
}
.btn {
  color: #6a96bc;
  border: 1px solid #6a96bc;
  border-radius: 5px;
  padding: 10px 50px;
  cursor: pointer;
  background: #0774d7;
  color: white;
  margin: 0 10px;
  // margin:auto;
  // text-align: center;
}
.EnterpriseInform {
  .content_wrap {
    padding-bottom: 50px;
    margin-bottom: 20px;
  }
  ::v-deep .el-tabs__content {
    padding: 0;
  }
  ::v-deep .el-tabs__header {
    margin-bottom: 5px;
  }
  ::v-deep .el-form {
    margin: 0 15px 5px;
    .el-form-item__content {
      justify-content: left;
    }
  }
  .title {
    height: 50px;
    line-height: 50px;
    border: none;
  }
  .record_table {
    margin-top: 0;
  }
  .link {
    cursor: pointer;
    color: #0099ff;
  }
}
.back_btn {
  height: 26px;
  bottom: 7px;
  padding: 0 18px;
  border-radius: 14px;
}
.wrap_style ::v-deep .el-form-item__content {
  display: block !important;
}
.filelist {
  margin-bottom: 10px;
}
.btn_wrap2 {
  height: 40px;
  text-align: left;
  padding: 10px;
  margin: auto 30px;
  .btn2 {
    color: #0099ff;
    background: #fafafa;
    height: 30px;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    display: inline-block;
    border: 1px solid #2db7f5;
    text-align: center;
    border-radius: 23px;
    color: #0099ff;
    background: #fafafa;
    cursor: pointer;
  }
}
</style>
